<template>
  <!-- <div id="app" style="min-width: 1530px; width: 100%"> -->
  <div id="app" style="min-width: 1260px">
    <router-view></router-view>
    <AiAssistant />
  </div>
</template>

<script>
import AiAssistant from "@/components/AiAssistant/index.vue";

export default {
  name: "App",
  components: { AiAssistant },
};
</script>

<style scoped lang="less"></style>
